/**
 * The /stock/counts search params and their guard (§5).
 *
 * Apart from the page for the same reason the ledger's and the lot browser's
 * parsers are: `validateSearch` runs in the route module the router loads
 * eagerly, so a parser that imported the page would drag the list, the drawer and
 * the review table into the initial bundle.
 *
 * The review screen itself (`/stock/counts/$countNo`) takes no parameters: its two
 * dialogs are decisions in progress, and a link that reopens a confirmation
 * nobody asked for is a trap rather than a shareable view.
 */
import { COUNT_FILTERS, type CountFilter } from '@aslen/core';

export interface CountsSearch {
  /** The state chip; "all" is the default and stays out of the URL. */
  f?: CountFilter;
  /** csv of warehouse ids — the "Depo: tümü ▾" chip. */
  warehouse?: string;
  /** `?new=1` opens the "Sayım başlat" drawer. */
  new?: boolean;
}

const str = (v: unknown): string | undefined => (typeof v === 'string' && v.trim() ? v : undefined);
// the router parses `?new=1` into the number 1 and `?new=true` into a boolean,
// and a link pasted by hand may carry either spelling
const flag = (v: unknown): boolean | undefined => (v === true || v === 1 || v === '1' || v === 'true' ? true : undefined);

export function parseCountsSearch(s: Record<string, unknown>): CountsSearch {
  const f = (COUNT_FILTERS as readonly string[]).includes(s.f as string) ? (s.f as CountFilter) : undefined;
  return { f: f === 'all' ? undefined : f, warehouse: str(s.warehouse), new: flag(s.new) };
}
